import ReactDOM from 'react-dom/client';
import App from './App';
import { initSentry } from './sentry.ts';
import { polyFill } from './polyfill.ts';

initSentry();
polyFill();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);
